// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__323eY","text":"style_text__2-gAP"};